export enum Gender {
	MALE = 'male',
	FEMALE = 'female',
	OTHERS = 'others',
}

export interface User {
	email: string
	name: string
	gender: Gender
	phone: number | ''
	sessionId: string
	startDateTime: number
	endDateTime: number
	timelineId: string
	id: number | null
	hasPlacedOrder: boolean
	latitude: number | null
	longitude: number | null
	userWinning: any
	winnerList: any
}

export interface UserLocationType {
	latitude: number | null
	longitude: number | null
}
